import View from '../../../core/view';

import { withRouter } from 'react-router';
import {createRef} from "react";
import { Link } from "react-router-dom";
import { Row, Col} from "reactstrap";
import {Image} from "react-bootstrap";

import NoInternetConnectionViewController from '../../../viewController/static/noInternetConnectionViewController';

import SidebarMenuView from "../../component/sideMenu/sidebarMenuView";

import Session from "../../../helper/session";

import default_avatar from '../../../assets/images/default_avatar.png';
import logo_white from '../../../assets/images/logo_white.png';

import "./masterLayout.scss";

class MasterLayoutView extends View
{
	constructor(props)
	{
		super(props)
	
		this.state =
		{
			isOnline:true,
			isOptionsSheetOpen:false,
			searchKey: '',
			searchValue:"user",
			searchLabel:this.i18n('title_users'),


		}
		this._optionsDropdown = createRef(null);
		this._listOfOptions = 
        [
            { "value": "user", "label": this.i18n('title_users') },
            { "value": "tournaments", "label": this.i18n('title_tournaments')},
			{ "value": "playgrounds", "label": this.i18n('title_playgrounds')},
			{ "value": "flags", "label": this.i18n('title_flags')},
        ];
	}

	toggleCollapse()
	{
		this._isMounted && this.setState({...this.state, isCollapsed: !this.state.isCollapsed});
	}

	handleSearchChanges(e)
	{
		this._isMounted && this.setState({...this.state, searchKey:e.target.value});
	}
	

	clearSearchResults()
	{
		document.getElementById("search").value = "";
		this._isMounted && this.setState({...this.state, searchKey:''});
	}
	
	searchForUsers()
	{
		alert(this.props?.searchKey)
	}

	toggleProfileModal()
	{
		this._isMounted && this.props?.toggleModal("open",'userProfileModal')
	}

	toggleOptions()
    {
        this._isMounted && this.setState({...this.state, isOptionsSheetOpen : !this.state?.isOptionsSheetOpen});
	}
	
	handleOptionDropdownClickEvent(value,label)
    {
		this._isMounted && this.setState({...this.state,  searchValue:value ,searchLabel:value});
	}

	updateInternetConnection(flag)
    {
		this._isMounted && this.setState({...this.state, isOnline:flag});
			
		if(flag === false)
		{
			this._isMounted && this.showErrMsg(this.i18n('common_noInternet'), 'warning');
		}
	}

	recheckInternetConnection()
    {
        if(window.navigator.onLine === false)
        {
            this._isMounted && this.updateInternetConnection(false);
        } 
    }

	viewDidMount()
	{
		this._isMounted && window.addEventListener('online', () => this.updateInternetConnection(true));
        this._isMounted && window.addEventListener('offline', () => this.updateInternetConnection(false));
        
        if(window.navigator.onLine === false)
        {
            this._isMounted && this.updateInternetConnection(false);
        } 
	}

	viewDidUnmount()
    {
        this._isMounted && window.removeEventListener('online', () => this.updateInternetConnection(true));
        this._isMounted && window.removeEventListener('offline', () => this.updateInternetConnection(false));
    }


    render()
    {
		const prefs = Session.getPreferences();		
		

        return (
			<>
				{this.state?.isOnline
				?
					<div style={{direction:prefs?.dir}} className={`masterLayout-mainContainer h-100 p-4 t-bg-secondary`}>
						<div className={`masterLayout-bodyContainer`}>
							<div className={`masterLayout-headerContainer t-bg-secondary`}>
								<Row className={`m-0 p-0 align-items-center ${prefs?.dir}-primaryFont pb-4`}>
									<Col  className={`p-0 m-0 d-none d-md-block`}>
										<Link className="naked" to="/">
											<Image
												src={logo_white}
												alt="logo_white"
												width={"150px"}
											/>
										</Link>
									</Col>
									
									<Col className={`p-0 m-0`}>
										<div className={`p-0 m-0 d-flex justify-content-end align-items-center`}>
											<div className={`p-0 m-0 px-2 d-none d-lg-flex`}>
												<div className={` p-0 m-0 text-justify d-none d-lg-block t-text-alternative-highlight font-md `}>
													{`${this.i18n('common_welcome')} 👋`}
												</div>
												<div className={`p-0 m-0 d-none d-lg-block text-justify t-text-alternative-highlight font-md`}>
													{`${this.i18n('common_admin')}`}
												</div>
											</div>
											<div className={`m-0 ${prefs?.dir === "ltr" ? 'ps-3' : 'pe-3'}`}>
												<div style={{backgroundImage : `url(${default_avatar})`}} className={`pointer opacity-hover m-0 masterLayout-user-avatar`}/>
											</div>
										</div>
									</Col>
								</Row>
							</div>
							<div className={`h-100 masterLayout-childrenContainer rounded-sm t-bg-primary-highlight not-scrollable`}>
								<Row className="h-100 p-0 m-0">
									<Col xs={0} md={1} className={`d-none d-md-block masterLayout-sidebarMenu ${prefs?.dir}-rounded-leading t-bg-primary p-0 `}>
										<SidebarMenuView
											key={this.props?.sideMenuKey}
											toggleProfileModal={this.toggleProfileModal.bind(this)}
										/>
									</Col>
									<Col xs={12} md={11} className={`m-0 p-0 px-5 ${prefs?.dir}-rounded-sm-trailing masterLayout-children h-100 `}>
										{this.props?.children}
									</Col>
								</Row>
							</div>
						</div>
						
					</div>
				:
					<NoInternetConnectionViewController buttonAction={this.recheckInternetConnection.bind(this)} />
				}
			</>
        );
    }
}

export default withRouter(MasterLayoutView)